import styled, { css } from 'vue-styled-components';

import NextIcon from '@svgIcons/next2.svg';

import { FLEX_COLUMN_ALIGN_CENTER_DIV } from '@styles/common.styled.component';

import { BreakPoint, pickBreakpoint } from '@/utils/layout';

export default {
    props: {
        active: Boolean,
        type: {
            type: String,
            required: true,
        },
        icon: { type: Object, required: true },
        activeIcon: { type: Object, required: true },
        beta: Boolean,
    },
    render() {
        let { isMobileSize, type, active, icon, activeIcon, beta } = this;

        const Icon = active ? activeIcon : icon;
        const tooltipTitle = `${this.$t(`NAVIGATION.${type}`)} ${
            beta ? `(${this.$t('COMMON.beta')})` : ''
        }`;

        return (
            <div>
                {this.wrapTooltip({
                    className: 'black-tooltip',
                    placement: 'right',
                    visible: !isMobileSize,
                    title: tooltipTitle,
                    content: (
                        <Wrapper active={active}>
                            <Icon />
                            <TextWrapper class="lnb-menu-text-wrapper">
                                <Text
                                    active={active}
                                    domPropsInnerHTML={this.$t(
                                        `NAVIGATION.${type}`
                                    )}
                                />
                                <NextIcon
                                    v-view-box
                                    class="lnb-menu-next-icon"
                                />
                            </TextWrapper>
                        </Wrapper>
                    ),
                })}
            </div>
        );
    },
};
const Wrapper = styled(FLEX_COLUMN_ALIGN_CENTER_DIV, { active: Boolean })`
    position: relative;
    width: 60px;
    height: 60px;
    padding: 4px 0px;
    justify-content: center;
    gap: 6px;
    flex-shrink: 0;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: var(--color-gray-white);

    // Only currentColor icons follow this; the others bake their fill into a
    // paired _on asset and ignore it.
    color: ${({ active }) =>
        active ? 'var(--color-blue-50)' : 'var(--color-gray-100)'};

    svg {
        flex-shrink: 0;
    }

    .lnb-menu-next-icon {
        width: 24px;
        height: 24px;
        margin-left: auto;
        display: none;
    }

    &:hover {
        background-color: var(--color-gray-5);
    }

    @media screen and (max-width: ${pickBreakpoint(BreakPoint.lg) - 1}px) {
        width: 36px;
        height: 36px;

        .lnb-menu-text-wrapper {
            display: none;
        }

        .lnb-menu-beta-tag {
            display: none;
        }
    }

    @media screen and (max-width: ${pickBreakpoint(BreakPoint.md) - 1}px) {
        width: 100%;
        height: 48px;
        flex-direction: row;
        justify-content: flex-start;

        .lnb-menu-text-wrapper {
            display: flex;
            flex-direction: row;

            & div {
                font-size: 15px;
                line-height: 24px;
                text-align: start;
            }
        }

        .lnb-menu-beta-tag {
            display: block;
            position: relative;
            top: 0;
            left: 0;
            padding: 6px;

            font-size: 13px;
        }

        .lnb-menu-next-icon {
            display: block;
        }
    }
`;

const TextWrapper = styled(FLEX_COLUMN_ALIGN_CENTER_DIV)`
    gap: 3px;
`;

const Text = styled('div', { active: Boolean })`
    font-size: 10px;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: -0.1px;
    text-align: center;
    word-break: break-word;
    transition: all 0.2s ease;
    white-space: pre-line;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

    ${({ active }) =>
        active
            ? css`
                  color: var(--color-blue-60);
              `
            : css`
                  color: var(--color-gray-100);
              `}
`;

const BetaTag = styled.div`
    position: absolute;
    top: 4px;
    right: 4px;

    padding: 0px 3px;
    border-radius: 32px;
    border: 1px solid var(--color-gray-30);
    background: var(--color-gray-white);

    color: var(--color-gray-100);
    font-size: 8px;
    font-weight: 400;
    line-height: 10px;
    text-transform: uppercase;
`;
